import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {rolesRouting} from './roles.routing';
import {RoleComponent} from "./role.component";

import {TabViewModule} from 'primeng/tabview';
import {ButtonModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {DialogModule} from 'primeng/primeng';

@NgModule({
	imports: [
    CommonModule,
    FormsModule,
	  ButtonModule,
	  rolesRouting,
    InputTextModule,
    TabViewModule,
    DropdownModule,
    CheckboxModule,
    DialogModule
	],
    declarations: [
        RoleComponent
    ],
    exports: [
        RoleComponent
    ]
})
export class RolesModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/roles/roles.module.ts